import React, { useEffect, useRef, useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
    Button, Checkbox, Card, CardContent, CardHeader, FormControl, FormControlLabel, Hidden, FormHelperText, Grid, InputLabel, InputAdornment,
    Link, MenuItem, Radio, RadioGroup, Select, Typography, TextField
} from '@material-ui/core';
import { CreditCard, DateRange, VpnKey } from '@material-ui/icons';
import { genfunction } from '../../../helpers';
import { actionPostPaymentTransaction, actionResetPaymentTransaction, actionShopCartShowTransFee } from 'actions';
import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';
import { useDispatch, useSelector } from 'react-redux';
import DialogeBox from '../../../components/DialogeBox/DialogeBox';
import ReactHtmlParser from 'react-html-parser';
import MaskedInput from 'react-text-mask';
import { actionResetFormErrorState, actionSetFormErrorState, actionSetFieldValueState } from 'actions';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import { actionGetCustomer, actionResetCustomer } from 'actions';
import { actionShopCartSetRefundType, actionShopCartSetAdditionalBookingAmount, actionShopCartSetMmbAmountToPay } from 'actions';
import { actionGetCountryAndState } from 'actions';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Payments from '../../../components/Payments/Payments';
import { Autocomplete } from '@material-ui/lab';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import MultiPayments from '../../Checkout/components/MultiPayments';
import { useDebouncedCallback } from 'use-debounce';
import { actionStopUserToPurchase } from 'actions';
import { actionValidateRecaptchaToken } from 'actions';

const { EnableAlternateMerchantOnline, EmailRegex, PhoneNumberMessage, spreedlyEnvironment, RecaptchaV3Client, TermsnConditionCheckBoxText,
    TermsnConditionCheckMsg, UseStreetAddressForAVS, ShowFullAddressOnCheckout, PaymentMethodType, PhoneNumberMandatory, ApplyTransactionFee } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    }, primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    },
    box100per: {
        width: "100%"
    },
    box95per: {
        width: "97%"
    },
    iconforiframe: {
        marginTop: "18px"
    },
    iframebox: {
        marginTop: "-13px",
        height: "31px",
    },
    visible: {
        visibility: "visible"
    },
    hideVisiblity: {
        display: "none"
    },
    cancelbtnconfig:
    {
        marginTop: "-40px !important"
    },
    cancelbtnconfig10per:
    {
        marginTop: "10px !important"
    },
    clearButton: {
        "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
            color: theme.palette.primary.main
        }
    },
    AdjustContext: {
        padding: '12px'
    },
    button: {
        marginLeft: "10px",
        width: "30%"
    }
}));

function TextMaskCustom(props) {
    const { inputRef, onChange, value, ...other } = props;
    let pnMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return (
        <MaskedInput
            value={value}
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            onChange={onChange}
            mask={pnMask}
        />
    );
}

const CreditCardPayment = (props) => {

    const paymentsRef = useRef();
    var requiredFields = {};

    const classes = useStyles();
    const dispatch = useDispatch();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const events = useSelector(state => state.reducerShopCart.events);
    const errorstate = useSelector(state => state.reducerFormError.errorstate);
    const formfields = useSelector(state => state.reducerFormError.formfields);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
    const customer = useSelector(state => state.reducerCustomer);
    const managebkngTicketsModify = useSelector(state => state.reducerShopCart.managebookingticketsmodification);
    let shopcartamounttoPay = useSelector(state => state.reducerShopCart.mmbAmountToPay);
    let refundType = useSelector(state => state.reducerShopCart.refundType);
    const countryandstates = useSelector(state => state.reducerCountryAndState.countryandstate);
    const donation = useSelector(state => state.reducerShopCart.donation);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gatickets = useSelector(state => state.reducerShopCart.GATickets);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    let enteredAmountToPay = useSelector(state => state.reducerShopCart.enteredAmountToPay);
    const recaptacha = useSelector(state => state.reducerRecaptcha);
    const sessionID = useSelector(state => state.reducerGlobal.sessionID);
    const stopUserToPurchase = useSelector(state => state.reducerGlobal.stopUserToPurchase);
    const mmbHasPaid = useSelector(state => state.reducerShopCart.MMBHasPaid);

    const environmentKey = CryptoAES.decrypt(spreedlyEnvironment, '1271').toString(CryptoENC);
    const [CreditCardValue, setCreditCardValue] = React.useState(''); //NewCardDetails
    const [opentnc, setopentnc] = useState(false);
    const [tncchecked, settncChecked] = React.useState(false);
    const [errorMsg, seterrorMsg] = useState("");

    const paymenttranstate = useSelector(state => {
        return (
            {
                loading: state.reducerPaymentTransaction.loading,
                haspaid: state.reducerPaymentTransaction.Payment.hasOwnProperty('Products'),
                paymentinfo: state.reducerPaymentTransaction.Payment,
                errormsg: state.reducerPaymentTransaction.PaymentInfoError
            }
        )
    });

    let inputreferences = [];

    inputreferences.first_name = React.useRef();
    inputreferences.last_name = React.useRef();
    inputreferences.email = React.useRef();
    inputreferences.phone_number = React.useRef();
    inputreferences.address1 = React.useRef();
    inputreferences.country = React.useRef();
    inputreferences.state = React.useRef();
    inputreferences.city = React.useRef();
    inputreferences.zip = React.useRef();
    inputreferences.memberno = React.useRef();
    inputreferences.shipping_phone_number = React.useRef();
    inputreferences.shipping_address1 = React.useRef();
    inputreferences.shipping_city = React.useRef();
    inputreferences.shipping_state = React.useRef();
    inputreferences.shipping_zip = React.useRef();
    inputreferences.shipping_country = React.useRef();

    const openerrorpopup = () => {
        return (paymenttranstate.errormsg != "" || errorMsg != "")
    }

    const filterOptions = createFilterOptions({
        stringify: (option) => option.Country + '' + option.State,
    });

    useEffect(() => {
        if (shopcartamounttoPay > 0) {
            if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
                if (transactionfee.transactionFee[0].TransactionFeeByDefault) {
                    actionShopCartShowTransFee(dispatch, true);
                }
            }
        }

    }, [transactionfee])

    const handleReCaptchaVerify = useCallback(async () => {

        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available.');
            return;
        }

        let token = await executeRecaptcha('ecommerce');

        if (token.length > 0) {
            actionValidateRecaptchaToken(dispatch, token, sessionID);
        }
        else {
            seterrorMsg("Recaptcha token not fetched.");
        }

    }, [executeRecaptcha]);

    useEffect(() => {

        if ((events && events.length > 0) || refundType === "AdditionalPayment") {

            if (RecaptchaV3Client && RecaptchaV3Client != '' && (stopUserToPurchase !== undefined
                && stopUserToPurchase === false) && (sessionID !== undefined && sessionID.length > 0)
                && (recaptacha.validToken !== undefined && recaptacha.validToken === false)) {

                handleReCaptchaVerify();
            }
        }

    }, [handleReCaptchaVerify, RecaptchaV3Client, stopUserToPurchase, sessionID, recaptacha.validToken])


    useEffect(() => {
        if (paymenttranstate.errormsg.includes("Payment has been unsuccessful. To make this purchase, please contact us directly.")) {
            actionStopUserToPurchase(dispatch);
        }
    }, [paymenttranstate.errormsg]);

    useEffect(() => {
        if (recaptacha.validTokenError.length > 0) {
            seterrorMsg(recaptacha.validTokenError);
            actionStopUserToPurchase(dispatch);
        }

    }, [recaptacha.validTokenError]);

    const transFeeCheckHandler = (event) => {
        let transFee;

        if (refundType === "AdditionalPayment" || (refundType === "" && shopcartamounttoPay > 0)) {
            transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], enteredAmountToPay, cashlesstotal)
        }
        else {
            transFee = genfunction.TransactionFee(events, donation, transactionfee.transactionFee[0], cashless, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts);
        }

        let amoutToPay = event.target.checked ? genfunction.Rounded(shopcartamounttoPay + transFee) : genfunction.Rounded(shopcartamounttoPay - transFee);
        actionShopCartShowTransFee(dispatch, event.target.checked);
        actionShopCartSetMmbAmountToPay(dispatch, amoutToPay);
    };

    const transFeeCheckBox = () => {

        let showTFBox = true;

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeOptional === false && transactionfee.transactionFee[0].TransactionFeeByDefault === false) {
                showTFBox = false;
                if (!showTransFee && ApplyTransactionFee) {
                    actionShopCartShowTransFee(dispatch, true);
                }
            }
        }

        return showTFBox;
    };

    useEffect(() => {

        if (props.booking && props.booking.hasOwnProperty('CustomerID') && props.booking.CustomerID > 0 && mmbHasPaid === false) {

            let cstID = props.booking.CustomerID;
            if (props.booking.hasOwnProperty('BookingContactID') && props.booking.BookingContactID) {
                cstID = props.booking.BookingContactID;
            }

            actionGetCustomer(dispatch, cstID, props.booking.BookingEmailAddress);
        }
    }, []);

    useEffect(() => {
        if (props.amounttopay <= 0 || shopcartamounttoPay <= 0) {
            setCreditCardValue("");
        }
    }, [cashless])


    useEffect(() => {
        if (customer.customerError && customer.customerError.length > 0) {
            seterrorMsg(customer.customerError);
        }
    }, [customer]);

    useEffect(() => {

        if (shopcartamounttoPay == 0 && refundType !== "CancelBooking" && customer.customer && customer.customer.length > 0) {

            if (RecaptchaV3Client && RecaptchaV3Client != '') {
                executeRecaptcha("checkout").then(recaptchaToken => {
                    paymentTokenHandler({ token: "", cardtype: "" }, customer.customer && customer.customer.length > 0 ? customer.customer : "", recaptchaToken);
                }).catch(error => {
                    seterrorMsg("Recaptcha token not fetched")
                })
            }
            else {
                paymentTokenHandler({ token: "", cardtype: "" }, customer.customer && customer.customer.length > 0 ? customer.customer : "", "");
            }
        }
    }, [customer]);

    useEffect(() => {

        if (shopcartamounttoPay < 0 && (refundType == "GiftCardRefund" || refundType == "CancelGiftCardRefund") && customer.customer && customer.customer.length > 0) {
            actionShopCartSetRefundType(dispatch, refundType)

            if (RecaptchaV3Client && RecaptchaV3Client != '') {
                executeRecaptcha("checkout").then(recaptchaToken => {
                    paymentTokenHandler({ token: "", cardtype: "" }, customer.customer && customer.customer.length > 0 ? customer.customer : "", recaptchaToken);
                }).catch(error => {
                    seterrorMsg("Recaptcha token not fetched")
                })
            }
            else {
                paymentTokenHandler({ token: "", cardtype: "" }, customer.customer && customer.customer.length > 0 ? customer.customer : "", "");
            }
        }
    }, [customer]);

    useEffect(() => {

        if ((refundType == "CancelBooking" || refundType == "CreditCardRefund") && customer.customer && customer.customer.length > 0) {

            let cardonfileToken = "";
            let cardType = "";
            let cardMaskedNum = "";


            if (props.booking.hasOwnProperty('PaymentToken') && props.booking.PaymentToken.length > 0) {
                cardonfileToken = PaymentMethodType === "Spreedly" ?
                    props.booking.PaymentToken.substring(9, props.booking.PaymentToken.length) :
                    props.booking.PaymentToken.substring(props.booking.PaymentToken.length - 10);
            }

            if (props.booking.hasOwnProperty('PaymentDescription') && props.booking.PaymentDescription.length > 0) {
                cardType = PaymentMethodType === "Spreedly" ?
                    props.booking.PaymentDescription.substr(0, props.booking.PaymentDescription.indexOf('-')) :
                    props.booking.PaymentDescription.substring(0, props.booking.PaymentDescription.indexOf('-') - 1).trim();

                cardMaskedNum = props.booking.PaymentDescription.substring(props.booking.PaymentDescription.indexOf('-') + 1, props.booking.PaymentDescription.length).trim();
            }

            if (cardonfileToken.length > 0) {
                actionShopCartSetRefundType(dispatch, refundType);

                if (RecaptchaV3Client && RecaptchaV3Client != '') {
                    executeRecaptcha("checkout").then(recaptchaToken => {
                        paymentTokenHandler({ token: cardonfileToken, cardtype: cardType, cardnumber: cardMaskedNum }, customer.customer && customer.customer.length > 0 ? customer.customer : "", recaptchaToken);

                    }).catch(error => {
                        seterrorMsg("Recaptcha token not fetched")
                    })
                }
                else {
                    paymentTokenHandler({ token: cardonfileToken, cardtype: cardType, cardnumber: cardMaskedNum }, customer.customer && customer.customer.length > 0 ? customer.customer : "", "");
                }

            }
        }
    }, [customer]);

    const GetTransOptionalText = () => {
        let optionalTxt = '';
        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            optionalTxt = transactionfee.transactionFee[0].TransactionFeeOptionalText;

            if (refundType === "AdditionalPayment" || (refundType === "" && shopcartamounttoPay > 0))
                optionalTxt += ' [' + genfunction.ccyFormat(parseFloat(genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], enteredAmountToPay, cashlesstotal))) + ']';

            else
                optionalTxt += ' [' + genfunction.ccyFormat(parseFloat(genfunction.TransactionFee(events, donation, transactionfee.transactionFee[0], cashless, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts))) + ']';
        }

        return optionalTxt;
    }

    const errorcancelhandle = () => {
        actionResetPaymentTransaction(dispatch);
        seterrorMsg("");
    }

    const fieldhandleChange = (event) => {
        if (event.currentTarget.name === "checkBoxMember")
            actionSetFieldValueState(dispatch, event.currentTarget.name, event.target.checked);
        else if (event.target.name === "MonthSelect" || event.target.name === "YearSelect")
            actionSetFieldValueState(dispatch, event.target.name, event.target.value);
        else
            actionSetFieldValueState(dispatch, event.currentTarget.name, event.target.value);

    };

    const getTNC = () => {
        return ReactHtmlParser(TermsnConditionCheckMsg);
    }

    const handleChange = (event) => {
        setCreditCardValue(event.target.value);
    };

    const tnccheckeHandle = (event) => {
        settncChecked(event.target.checked);
    };

    const paymentTokenHandler = (token, client, recaptchaToken) => {
        actionPostPaymentTransaction(dispatch, token, client, recaptchaToken);
    }

    const changeBillingAddress = () => {
        actionSetFieldValueState(dispatch, 'billingAddressSame', !formfields.billingAddressSame.value);
    }

    const ZeroDollaroRGiftCardOnlyTransCall = () => {

        if (RecaptchaV3Client && RecaptchaV3Client != '') {
            executeRecaptcha("checkout").then(recaptchaToken => {
                paymentTokenHandler({ token: "", cardtype: "" }, customer.customer && customer.customer.length > 0 ? customer.customer : "", recaptchaToken);
            }).catch(error => {
                seterrorMsg("Recaptcha token not fetched")
            })
        }
        else {
            paymentTokenHandler({ token: "", cardtype: "" }, customer.customer && customer.customer.length > 0 ? customer.customer : "", "");
        }
    }

    const ProcessAndConfigurePaymentsWithoutCard = () => {

        if ((refundType == "AdditionalPayment" || refundType === "") && shopcartamounttoPay > 0) {

            if (cashlesstotal === 0) {
                actionShopCartSetAdditionalBookingAmount(dispatch, shopcartamounttoPay);
            }

            if (cashlesstotal > 0) {
                actionShopCartSetAdditionalBookingAmount(dispatch, shopcartamounttoPay - cashlesstotal);
            }
        }

        if (formfields.billingAddressSame.value) {
            billingAddressSameAsAbover();
        }

        reseterrorfield();

        requiredFields = BindRequiredFields();

        return requiredFields ? true : false;
    }

    const onChangeCountry = (event, value) => {
        actionSetFieldValueState(dispatch, "country", value === null ? "" : value.Country);
        onChangeState(event, null);
    }

    const onChangeState = (event, value) => {
        actionSetFieldValueState(dispatch, "state", value === null ? "" : value.State);
    }

    const onChangeShippingCountry = (event, value) => {
        if (value === null) {
            actionSetFieldValueState(dispatch, "shipping_country", "")
            actionSetFieldValueState(dispatch, "shipping_state", "")
        }
        else
            actionSetFieldValueState(dispatch, "shipping_country", value.Country);

        onChangeShippingState(event, null);
    }
    const onChangeShippingState = (event, value) => {
        actionSetFieldValueState(dispatch, "shipping_state", value === null ? "" : value.State);
    }

    useEffect(() => {
        actionGetCountryAndState(dispatch);

    }, [])

    useEffect(() => {
        if (countryandstates && countryandstates.length > 0) {
            if (formfields.country.value == "")
                actionSetFieldValueState(dispatch, "country", countryandstates[0].Country);
            if (formfields.shipping_country.value == "")
                actionSetFieldValueState(dispatch, "shipping_country", countryandstates[0].Country);

        }
    }, [countryandstates]);

    const isShowCountryFields = (columnName) => {
        return genfunction.GetValueFromCountryAndState(countryandstates, formfields.country.value, columnName);
    }

    const isShowShippingCountryFields = (columnName) => {
        return genfunction.GetValueFromCountryAndState(countryandstates, formfields.shipping_country.value, columnName);
    }

    const BindRequiredFields = () => {

        requiredFields = {};

        if (PhoneNumberMandatory) {
            requiredFields["phone_number"] = formfields.phone_number.value.trim();
            requiredFields["shipping_phone_number"] = formfields.shipping_phone_number.value;
        }

        requiredFields["email"] = formfields.email.value.trim();
        if (UseStreetAddressForAVS)
            requiredFields["address1"] = formfields.address1.value;
        requiredFields["country"] = formfields.country.value;
        requiredFields["city"] = formfields.city.value;

        if (isShowCountryFields("ShowState")) {
            requiredFields["state"] = formfields.state.value;
        }
        else {
            formfields.state.value = "0";
        }

        if (isShowCountryFields("ShowPostalCode")) {
            requiredFields["zip"] = formfields.zip.value;
        }
        else {
            formfields.zip.value = "0";
        }

        requiredFields["first_name"] = formfields.first_name.value;
        requiredFields["last_name"] = formfields.last_name.value;

        requiredFields["shipping_address1"] = formfields.shipping_address1.value;
        requiredFields["shipping_city"] = formfields.shipping_city.value;

        if (isShowShippingCountryFields("ShowState")) {
            requiredFields["shipping_state"] = formfields.shipping_state.value;
        }
        else {
            formfields.shipping_state.value = "0";
        }

        if (isShowShippingCountryFields("ShowPostalCode")) {
            requiredFields["shipping_zip"] = formfields.shipping_zip.value;
        }
        else {
            formfields.shipping_zip.value = "0";
        }

        requiredFields["shipping_country"] = formfields.shipping_country.value;

        if (ShowFullAddressOnCheckout == false) {
            requiredFields["address1"] = requiredFields["country"] = requiredFields["city"] = requiredFields["state"] = undefined;
            requiredFields["shipping_address1"] = requiredFields["shipping_country"] = requiredFields["shipping_city"] = requiredFields["shipping_state"] = undefined;
        }

        if (checkfieldvalidation(requiredFields) == false) { return; }

        if (validateEmail(requiredFields["email"]) == false) {
            errorfield("email", "Please enter a valid email address", true);
            inputreferences['email'].current.focus();
            window.scrollBy(0, -65);
            return;
        }
        else if (requiredFields["phone_number"] && validatePhoneNum(requiredFields["phone_number"]) == false) {
            errorfield("phone_number", "Please enter a valid phone #", true);
            inputreferences['phone_number'].current.focus();
            window.scrollBy(0, -65);
            return;
        }
        else if (requiredFields["shipping_phone_number"] && validatePhoneNum(requiredFields["shipping_phone_number"]) == false) {
            errorfield("shipping_phone_number", "Please enter a valid phone #", true);
            inputreferences['shipping_phone_number'].current.focus();
            window.scrollBy(0, -65);
            return;
        }
        else {
            if (PhoneNumberMandatory) {
                requiredFields["phone_number"] = formfields.phone_number.value;
                requiredFields["shipping_phone_number"] = formfields.shipping_phone_number.value;
            }

            requiredFields["address2"] = formfields.address2.value;
            requiredFields["shipping_address2"] = formfields.shipping_address2.value;

        }

        return requiredFields;
    }


    const submitPaymentForm = () => {

        if (shopcartamounttoPay === 0 || props.amounttopay === 0) {
            ZeroDollaroRGiftCardOnlyTransCall();
            return;
        }

        if (CreditCardValue === "NewCardDetails") {

            if (ProcessAndConfigurePaymentsWithoutCard()) {
                if (genfunction.subproducttotal(events, cashless, null, (showTransFee ? transactionfee.transactionFee[0] : null), null, null, null, [], []) > 0) {
                    requiredFields["month"] = formfields.MonthSelect.value;
                    requiredFields["year"] = formfields.YearSelect.value;
                    paymentsRef.current.SpreedlyTransactionCall(requiredFields);
                }
                else if ((refundType === 'AdditionalPayment' || refundType === "") && shopcartamounttoPay > 0) {
                    requiredFields["month"] = formfields.MonthSelect.value;
                    requiredFields["year"] = formfields.YearSelect.value;
                    paymentsRef.current.SpreedlyTransactionCall(requiredFields);
                }
                else {
                    paymentsRef.current.SpreedlyZeroDollarTransactionCall(requiredFields);
                }
            }
        }
        else {
            if ((refundType == "AdditionalPayment" || refundType === "") && shopcartamounttoPay > 0) {

                if (cashlesstotal === 0) {
                    actionShopCartSetAdditionalBookingAmount(dispatch, shopcartamounttoPay);
                }

                if (cashlesstotal > 0) {
                    actionShopCartSetAdditionalBookingAmount(dispatch, shopcartamounttoPay - cashlesstotal);
                }
            }

            paymentsRef.current.SpreedlyCardOnFileTransaction();
        }
    }

    const onClickPayBtn = useDebouncedCallback(submitPaymentForm, 5000, { leading: true });

    const PayByGlobalPayment = () => {

        if ((refundType == "AdditionalPayment" || refundType === "") && shopcartamounttoPay > 0) {

            if (cashlesstotal === 0) {
                actionShopCartSetAdditionalBookingAmount(dispatch, shopcartamounttoPay);
            }

            if (cashlesstotal > 0) {
                actionShopCartSetAdditionalBookingAmount(dispatch, shopcartamounttoPay - cashlesstotal);
            }
        }

        paymentsRef.current.PayByCardOnFile();
    }

    const onClickGPPayBtn = useDebouncedCallback(PayByGlobalPayment, 5000, { leading: true });

    const ManageNonPaymentMethodTrans = () => {
        if (CreditCardValue === "" && cashlesstotal > 0 && (parseFloat(shopcartamounttoPay) === parseFloat(cashlesstotal.toFixed(2)))) {
            ZeroDollaroRGiftCardOnlyTransCall();
        }
    }


    const CancelChanges = () => {
        props.onClickHandler()
    }

    const reseterrorfield = () => {
        actionResetFormErrorState(dispatch);
    }

    function validateEmail(email) {
        var re = new RegExp(EmailRegex);
        return re.test(String(email).toLowerCase());
    }

    function validatePhoneNum(phoneNum) {
        let cusNumber = phoneNum.replace(/\D/g, "");
        if (cusNumber != "" && cusNumber.length < 10) {
            return false;
        }
        return true;
    }

    const errorfield = (errorfield, errortext, errorstate) => {
        actionSetFormErrorState(dispatch, errorfield, errortext, errorstate)
    }

    const checkfieldvalidation = (fields) => {
        for (let prop in fields) {
            if (fields[prop] == "") {

                if (prop === 'phone_number') {
                    errorfield(prop, PhoneNumberMessage, true);
                }
                else {
                    errorfield(prop, prop + " is required.", true);
                }

                inputreferences[prop].current.focus();
                window.scrollBy(0, -65);
                return false
            }
            else {
                errorfield(prop, "", false)
            }
        }
        return true;
    }

    const billingAddressSameAsAbover = () => {

        formfields.shipping_address1.value = formfields.address1.value;
        formfields.shipping_address2.value = formfields.address2.value;
        formfields.shipping_city.value = formfields.city.value;
        formfields.shipping_state.value = formfields.state.value;
        formfields.shipping_zip.value = formfields.zip.value;
        formfields.shipping_country.value = formfields.country.value;
        formfields.shipping_phone_number.value = formfields.phone_number.value;
    }


    return (

        //Desktop and Laptop (smDown)
        //Tablet (xsDown mdUp)
        //Mobile (smUp)

        <Grid item xs={12} md={7}>
            <ErrorHandling msg={paymenttranstate.errormsg != "" ? paymenttranstate.errormsg : errorMsg} open={openerrorpopup()} handleclose={errorcancelhandle} />
            <Hidden smDown>
                <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: 5 }}>
                    Credit Card Payment
                </Typography>
            </Hidden>

            <Hidden xsDown mdUp>
                <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: 7 }}>
                    Credit Card Payment
                </Typography>
            </Hidden>

            <Hidden smUp>
                <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: 10 }}>
                    Credit Card Payment
                </Typography>
            </Hidden>


            <Card id="pform" className={classes.box100per}>
                <Grid item xs={12} md={12} align="center" style={{ marginTop: "15px" }} >

                    <FormControl component="fieldset">
                        <RadioGroup aria-label="creditcards" name="selectoption" value={CreditCardValue} onChange={handleChange} >
                            <FormControlLabel
                                value="UseCardOnFile"
                                control={<Radio />}
                                label={"Use (" + (props.booking && props.booking.hasOwnProperty('PaymentDescription') ? props.booking.PaymentDescription : 'Visa XXXX-XXXX-XXXX-1234') + ") Card on File"}
                                disabled={!(props.booking && props.booking.hasOwnProperty('PaymentDescription') && props.booking.PaymentDescription.length > 0)
                                    || (props.amounttopay <= 0 || shopcartamounttoPay <= 0)} />

                            <FormControlLabel value="NewCardDetails" control={<Radio />} label="Enter New Card Details"
                                // disabled={(props.amounttopay === 0 || shopcartamounttoPay === 0)}
                                disabled={(props.amounttopay <= 0 || shopcartamounttoPay <= 0)}
                            // || (refundType == "GiftCardRefund" || refundType === "CreditCardRefund" || refundType === "CancelBooking" || refundType === "CancelGiftCardRefund")}

                            />
                        </RadioGroup>
                    </FormControl>

                </Grid>

                {CreditCardValue === "NewCardDetails" || CreditCardValue === "UseCardOnFile" ?
                    <CardContent>
                        <Grid container>
                            <Grid container item xs={12} className={shopcartamounttoPay === 0 ? classes.hideVisiblity : classes.visible}>

                                <Grid container spacing={2}>

                                    {CreditCardValue === "NewCardDetails" ?
                                        <>
                                            <Grid item xs={6}>
                                                <TextField
                                                    id="Fname"
                                                    label="First Name"
                                                    name="first_name"
                                                    fullWidth={true}
                                                    autoFocus
                                                    inputRef={inputreferences['first_name']}
                                                    error={errorstate.first_name.errorstate}
                                                    helperText={errorstate.first_name.errortext}
                                                    onChange={fieldhandleChange}
                                                    value={formfields.first_name.value}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    id="Lname"
                                                    label="Last Name"
                                                    name="last_name"
                                                    fullWidth={true}
                                                    inputRef={inputreferences['last_name']}
                                                    error={errorstate.last_name.errorstate}
                                                    helperText={errorstate.last_name.errortext}
                                                    onChange={fieldhandleChange}
                                                    value={formfields.last_name.value}
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <TextField
                                                    id="Email"
                                                    label="Email"
                                                    name="email"
                                                    fullWidth={true}
                                                    inputRef={inputreferences['email']}
                                                    error={errorstate.email.errorstate}
                                                    helperText={errorstate.email.errortext}
                                                    type="email"
                                                    onChange={fieldhandleChange}
                                                    value={formfields.email.value}
                                                    inputProps={{
                                                        "data-hj-allow": ""
                                                    }}

                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    label={PhoneNumberMandatory ? "Phone #" : "Phone # (Optional)"}
                                                    onChange={fieldhandleChange}
                                                    value={formfields.phone_number.value}
                                                    name="phone_number"
                                                    fullWidth={true}
                                                    id="phone_number"
                                                    inputRef={inputreferences['phone_number']}
                                                    error={errorstate.phone_number.errorstate}
                                                    helperText={errorstate.phone_number.errortext}
                                                    InputProps={{
                                                        inputComponent: TextMaskCustom
                                                    }}
                                                >
                                                </TextField>
                                            </Grid>
                                            {ShowFullAddressOnCheckout ?
                                                <>

                                                    <Grid item xs={12} md={12}>

                                                        {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) ?

                                                            <FormControl className={classes.box100per} error={errorstate.country.errorstate}>
                                                                <Autocomplete filterOptions={filterOptions}
                                                                    id="country"
                                                                    name="country"
                                                                    options={countryandstates}
                                                                    fullWidth={true}
                                                                    onChange={onChangeCountry}
                                                                    autoHighlight
                                                                    getOptionLabel={(option) => {
                                                                        if (option.hasOwnProperty('Country')) {
                                                                            return option.Country;
                                                                        }
                                                                        return option;
                                                                    }}
                                                                    value={formfields.country.value}
                                                                    renderOption={(option) => (
                                                                        <>
                                                                            <img
                                                                                loading="lazy"
                                                                                width="40"
                                                                                src={`https://flagcdn.com/w40/${option.ISOCode}.png`}
                                                                                srcSet={`https://flagcdn.com/w80/${option.ISOCode}.png 2x`}
                                                                                alt=""
                                                                                style={{ margin: "10px" }}
                                                                            />
                                                                            {` ${option.Country} `}</>
                                                                    )}

                                                                    style={{ width: "100%" }}
                                                                    renderInput={(params) =>
                                                                    (<TextField inputRef={inputreferences['country']} label="Country" variant='outlined' className={classes.clearButton}{...params}
                                                                    />
                                                                    )}

                                                                />
                                                                <FormHelperText>{errorstate.country.errortext}</FormHelperText>
                                                            </FormControl>
                                                            : ""}

                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            id="address1"
                                                            name="address1"
                                                            label="Address 1"
                                                            inputRef={inputreferences['address1']}
                                                            fullWidth={true}
                                                            error={errorstate.address1.errorstate}
                                                            helperText={errorstate.address1.errortext}
                                                            onChange={fieldhandleChange}
                                                            value={formfields.address1.value}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            id="address2"
                                                            name="address2"
                                                            label="Address 2 (Optional)"
                                                            fullWidth={true}
                                                            error={errorstate.address2.errorstate}
                                                            helperText={errorstate.address2.errortext}
                                                            onChange={fieldhandleChange}
                                                            value={formfields.address2.value}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={12}>
                                                        <TextField
                                                            id="city"
                                                            label={isShowCountryFields("CityText")}
                                                            name="city"
                                                            inputRef={inputreferences['city']}
                                                            fullWidth={true}
                                                            error={errorstate.city.errorstate}
                                                            helperText={errorstate.city.errortext}
                                                            onChange={fieldhandleChange}
                                                            value={formfields.city.value}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={isShowCountryFields("ShowPostalCode") ? 6 : 12}>

                                                        {isShowCountryFields("ShowState") ?
                                                            <FormControl className={classes.box100per} error={errorstate.state.errorstate}>

                                                                <Autocomplete filterOptions={filterOptions}
                                                                    id="state"
                                                                    name="state"
                                                                    autoHighlight
                                                                    options={
                                                                        formfields.country.value ? countryandstates.filter(
                                                                            x => x.Country == formfields.country.value).map(o => o.hasOwnProperty("Picklist") ? o.Picklist : [])[0]
                                                                            : []
                                                                    }
                                                                    fullWidth={true}
                                                                    onChange={onChangeState}
                                                                    getOptionLabel={(option) => {
                                                                        if (option.hasOwnProperty('State')) {
                                                                            return option.State;
                                                                        }
                                                                        return option;
                                                                    }}
                                                                    value={formfields.state.value}
                                                                    style={{ width: "100%" }}
                                                                    renderInput={(params) =>
                                                                    (<TextField inputRef={inputreferences['state']} label="State" variant='outlined' className={classes.clearButton}{...params}
                                                                    />
                                                                    )}

                                                                />
                                                                <FormHelperText>{errorstate.state.errortext}</FormHelperText>
                                                            </FormControl>
                                                            : ""}

                                                    </Grid>
                                                </>
                                                : ""}
                                            <Grid item xs={12} md={isShowCountryFields("ShowState") ? 6 : 12}>
                                                {isShowCountryFields("ShowPostalCode") ?

                                                    <TextField
                                                        id="zip"
                                                        label={isShowCountryFields("PostalCodeName")}
                                                        name="zip"
                                                        inputRef={inputreferences['zip']}
                                                        fullWidth={true}
                                                        error={errorstate.zip.errorstate}
                                                        helperText={errorstate.zip.errortext}
                                                        onChange={fieldhandleChange}
                                                        value={formfields.zip.value}
                                                    />

                                                    : ""}
                                            </Grid>
                                            {ShowFullAddressOnCheckout ?
                                                <>
                                                    <Grid item xs={12}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                                    name="checkboxBillingAddress"
                                                                    color="primary"
                                                                    onChange={() => changeBillingAddress()}
                                                                    checked={formfields.billingAddressSame.value}
                                                                />
                                                            }
                                                            label="Billing Address same as above"
                                                        />
                                                    </Grid>

                                                    {formfields.billingAddressSame.value == false ?
                                                        <>
                                                            <Grid item xs={12}>
                                                                <Typography variant="h4">Billing Address</Typography>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    label={PhoneNumberMandatory ? "Phone #" : "Phone # (Optional)"}
                                                                    onChange={fieldhandleChange}
                                                                    value={formfields.shipping_phone_number.value}
                                                                    name="shipping_phone_number"
                                                                    fullWidth={true}
                                                                    id="shipping_phone_number"
                                                                    inputRef={inputreferences['shipping_phone_number']}
                                                                    error={errorstate.shipping_phone_number.errorstate}
                                                                    helperText={errorstate.shipping_phone_number.errortext}
                                                                    InputProps={{
                                                                        inputComponent: TextMaskCustom
                                                                    }}
                                                                >
                                                                </TextField>
                                                            </Grid>

                                                            <Grid item xs={12} md={12}>
                                                                {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) ?

                                                                    <FormControl className={classes.formControl + " " + classes.box100per} error={errorstate.shipping_country.errorstate}>

                                                                        <Autocomplete filterOptions={filterOptions}
                                                                            id="shipping_country"
                                                                            name="shipping_country"
                                                                            options={countryandstates}
                                                                            fullWidth={true}
                                                                            onChange={onChangeShippingCountry}
                                                                            autoHighlight
                                                                            getOptionLabel={(option) => {
                                                                                if (option.hasOwnProperty('Country')) {
                                                                                    return option.Country;
                                                                                }
                                                                                return option;
                                                                            }}
                                                                            value={formfields.shipping_country.value}
                                                                            renderOption={(option) => (
                                                                                <>
                                                                                    <img
                                                                                        loading="lazy"
                                                                                        width="40"
                                                                                        src={`https://flagcdn.com/w40/${option.ISOCode}.png`}
                                                                                        srcSet={`https://flagcdn.com/w80/${option.ISOCode}.png 2x`}
                                                                                        alt=""
                                                                                        style={{ margin: "10px" }}
                                                                                    />
                                                                                    {` ${option.Country} `}</>
                                                                            )}

                                                                            style={{ width: "100%" }}
                                                                            renderInput={(params) =>
                                                                            (<TextField inputRef={inputreferences['shipping_country']} label="Country" variant='outlined' className={classes.clearButton}{...params}
                                                                            />
                                                                            )}

                                                                        />
                                                                        <FormHelperText>{errorstate.shipping_country.errortext}</FormHelperText>
                                                                    </FormControl>
                                                                    : ""}

                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    id="shipping_address1"
                                                                    name="shipping_address1"
                                                                    label="Address 1"
                                                                    inputRef={inputreferences['shipping_address1']}
                                                                    fullWidth={true}
                                                                    error={errorstate.shipping_address1.errorstate}
                                                                    helperText={errorstate.shipping_address1.errortext}
                                                                    onChange={fieldhandleChange}
                                                                    value={formfields.shipping_address1.value}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    id="shipping_address2"
                                                                    name="shipping_address2"
                                                                    label="Address 2 (Optional)"
                                                                    fullWidth={true}
                                                                    error={errorstate.shipping_address2.errorstate}
                                                                    helperText={errorstate.shipping_address2.errortext}
                                                                    onChange={fieldhandleChange}
                                                                    value={formfields.shipping_address2.value}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={12}>
                                                                <TextField
                                                                    id="shipping_city"
                                                                    label={isShowShippingCountryFields("CityText")}
                                                                    name="shipping_city"
                                                                    inputRef={inputreferences['shipping_city']}
                                                                    fullWidth={true}
                                                                    error={errorstate.shipping_city.errorstate}
                                                                    helperText={errorstate.shipping_city.errortext}
                                                                    onChange={fieldhandleChange}
                                                                    value={formfields.shipping_city.value}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={isShowShippingCountryFields("ShowPostalCode") ? 6 : 12}>
                                                                {isShowShippingCountryFields("ShowState") ?

                                                                    <FormControl className={classes.formControl + " " + classes.box100per} error={errorstate.shipping_state.errorstate}>

                                                                        <Autocomplete filterOptions={filterOptions}
                                                                            id="shipping_state"
                                                                            name="shipping_state"
                                                                            autoHighlight
                                                                            options={
                                                                                formfields.shipping_country.value ? countryandstates.filter(
                                                                                    x => x.Country == formfields.shipping_country.value).map(o => o.hasOwnProperty("Picklist") ? o.Picklist : [])[0]
                                                                                    : []
                                                                            }
                                                                            fullWidth={true}
                                                                            onChange={onChangeShippingState}
                                                                            getOptionLabel={(option) => {
                                                                                if (option.hasOwnProperty('State')) {
                                                                                    return option.State;
                                                                                }
                                                                                return option;
                                                                            }}
                                                                            value={formfields.shipping_state.value}
                                                                            style={{ width: "100%" }}
                                                                            renderInput={(params) =>
                                                                            (<TextField inputRef={inputreferences['shipping_state']} label="State" variant='outlined' className={classes.clearButton}{...params}
                                                                            />
                                                                            )}

                                                                        />
                                                                        <FormHelperText>{errorstate.shipping_state.errortext}</FormHelperText>
                                                                    </FormControl>
                                                                    : ""}
                                                            </Grid>

                                                            <Grid item xs={12} md={isShowShippingCountryFields("ShowState") ? 6 : 12}>
                                                                {isShowShippingCountryFields("ShowPostalCode") ?

                                                                    <TextField
                                                                        id="shipping_zip"
                                                                        label={isShowShippingCountryFields("PostalCodeName")}
                                                                        name="shipping_zip"
                                                                        inputRef={inputreferences['shipping_zip']}
                                                                        fullWidth={true}
                                                                        error={errorstate.shipping_zip.errorstate}
                                                                        helperText={errorstate.shipping_zip.errortext}
                                                                        onChange={fieldhandleChange}
                                                                        value={formfields.shipping_zip.value}
                                                                    />
                                                                    : ""}
                                                            </Grid>

                                                        </>
                                                        : null}
                                                </> : ""}
                                        </>
                                        : null}

                                    {PaymentMethodType === "Spreedly" ?
                                        <>
                                            <Grid item xs={12} className={CreditCardValue === "UseCardOnFile" ? classes.hideVisiblity : classes.visible}>
                                                <Payments type={PaymentMethodType} ref={paymentsRef}
                                                    showFreeTkt={false}
                                                    managemyBooking={true}
                                                    mmbPayBy={CreditCardValue}
                                                    ValidatePaymentFields={ProcessAndConfigurePaymentsWithoutCard}
                                                    AdditionBooking={refundType === 'AdditionalPayment' ? true : false}
                                                />
                                            </Grid>

                                            {ApplyTransactionFee && transFeeCheckBox() === true && !(props.amounttopay <= 0 || shopcartamounttoPay <= 0)
                                                ?
                                                < Grid item xs={12} >
                                                    <Checkbox
                                                        color="primary"
                                                        checked={showTransFee}
                                                        onChange={transFeeCheckHandler}
                                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                    />
                                                    <Typography color="textSecondary" component="span" >
                                                        {GetTransOptionalText()}
                                                    </Typography>
                                                </Grid>
                                                : null}

                                            <Grid item xs={12}>
                                                <Checkbox
                                                    color="primary"
                                                    checked={tncchecked}
                                                    onChange={tnccheckeHandle}
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                                <Typography color="textSecondary" component="span" >
                                                    {TermsnConditionCheckBoxText}
                                                    <Link href="#" onClick={() => { setopentnc(true) }} > Terms and Conditions </Link>
                                                </Typography>

                                            </Grid>

                                            <Grid item xs={12}>
                                                {tncchecked && EnableAlternateMerchantOnline && (orderProducts && orderProducts.length < 1) ? <MultiPayments /> : null}
                                            </Grid>

                                            <Grid item xs={12} align="center" style={{ marginTop: "10px" }}>

                                                <Grid item xs={12} align="center" className={classes.AdjustContext}>
                                                    <Button
                                                        disabled={stopUserToPurchase === true || onClickPayBtn.isPending() || !((tncchecked && CreditCardValue !== "")
                                                            || (tncchecked && CreditCardValue === "" && shopcartamounttoPay <= 0)
                                                            || (tncchecked && props.amounttopay <= 0)) || errorstate.cvv.errorstate}
                                                        variant="contained" size="medium"
                                                        className={classes.primarycolor + " " + classes.AdjustContext + " " + classes.button}
                                                        onClick={onClickPayBtn} >
                                                        Pay</Button>

                                                    <Button variant="outlined" size="medium"
                                                        className={classes.primarycolor + " " + classes.AdjustContext + " " + classes.button}
                                                        onClick={CancelChanges} >Cancel Changes</Button>

                                                </Grid>

                                            </Grid>
                                        </>
                                        :
                                        <>

                                            <Grid item xs={12} className={CreditCardValue === "UseCardOnFile" ? 'hidden' : classes.visible}>
                                                <Payments type={PaymentMethodType} ref={paymentsRef} onClick={CancelChanges}
                                                    showFreeTkt={false}
                                                    managemyBooking={true}
                                                    mmbPayBy={CreditCardValue}
                                                    ValidatePaymentFields={ProcessAndConfigurePaymentsWithoutCard}
                                                    AdditionBooking={refundType === 'AdditionalPayment' ? true : false}
                                                />
                                            </Grid>

                                            {CreditCardValue === "UseCardOnFile" ?
                                                <>
                                                    {ApplyTransactionFee && transFeeCheckBox() === true && !(props.amounttopay <= 0 || shopcartamounttoPay <= 0)
                                                        ?
                                                        < Grid item xs={12} >
                                                            <Checkbox
                                                                color="primary"
                                                                checked={showTransFee}
                                                                onChange={transFeeCheckHandler}
                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                            />
                                                            <Typography color="textSecondary" component="span" >
                                                                {GetTransOptionalText()}
                                                            </Typography>
                                                        </Grid>
                                                        : null}

                                                    <Grid item xs={12}>
                                                        <Checkbox
                                                            color="primary"
                                                            checked={tncchecked}
                                                            onChange={tnccheckeHandle}
                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                        />
                                                        <Typography color="textSecondary" component="span" >
                                                            {TermsnConditionCheckBoxText}
                                                            <Link href="#" onClick={() => { setopentnc(true) }} > Terms and Conditions </Link>
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        {tncchecked && EnableAlternateMerchantOnline && (orderProducts && orderProducts.length < 1) ? <MultiPayments /> : null}
                                                    </Grid>

                                                    <Grid xs={12} align="center" className={classes.AdjustContext}  >
                                                        <Button size="medium"
                                                            disabled={stopUserToPurchase == true || onClickGPPayBtn.isPending() || !((tncchecked && CreditCardValue !== "") || (tncchecked && CreditCardValue === "" && shopcartamounttoPay === 0) || (tncchecked && props.amounttopay === 0))}
                                                            variant="contained" className={classes.primarycolor + " " + classes.AdjustContext + " " + classes.button} onClick={onClickGPPayBtn} >Pay</Button>

                                                        <Button size="medium" variant="outlined"
                                                            className={classes.primarycolor + " " + classes.AdjustContext + " " + classes.button
                                                                //  + " " +  (CreditCardValue.length > 0 && CreditCardValue == "NewCardDetails" ? classes.cancelbtnconfig : classes.cancelbtnconfig10per)
                                                            }
                                                            onClick={CancelChanges} >Cancel Changes</Button>

                                                    </Grid>
                                                </>
                                                : null}

                                        </>
                                    }

                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                    : null}

                {CreditCardValue === "" ?
                    <>
                        {ApplyTransactionFee && transFeeCheckBox() === true && !(props.amounttopay <= 0 || shopcartamounttoPay <= 0)
                            ?
                            < Grid item xs={12} >
                                <Checkbox
                                    color="primary"
                                    checked={showTransFee}
                                    onChange={transFeeCheckHandler}
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                />
                                <Typography color="textSecondary" component="span" >
                                    {GetTransOptionalText()}
                                </Typography>
                            </Grid>
                            : null}

                        <Grid item xs={12}>
                            <Checkbox
                                color="primary"
                                checked={tncchecked}
                                onChange={tnccheckeHandle}
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <Typography color="textSecondary" component="span" >
                                {TermsnConditionCheckBoxText}
                                <Link href="#" onClick={() => { setopentnc(true) }} > Terms and Conditions </Link>
                            </Typography>
                        </Grid>


                        <Grid item xs={12} align="center" className={classes.AdjustContext}>
                            <Button
                                disabled={!(tncchecked && CreditCardValue === "" && shopcartamounttoPay > 0)}
                                size="medium"
                                variant="contained" className={classes.primarycolor + " " + classes.AdjustContext + " " + classes.button} onClick={ManageNonPaymentMethodTrans} >Pay</Button>

                            <Button
                                variant="outlined" size="medium"
                                className={classes.primarycolor + " " + classes.AdjustContext + " " + classes.button}
                                onClick={CancelChanges} >Cancel Changes</Button>
                        </Grid>
                    </>
                    :
                    null
                }

                <DialogeBox open={opentnc} title={"Terms and Conditions"}
                    message={getTNC()}
                    button1text={"Close"}
                    button1clickhandler={() => { setopentnc(false) }}></DialogeBox>
            </Card>
        </Grid >
    );
};

export default CreditCardPayment;
